<template>
    <div class="hello">
        <h1>{{ title }}</h1>

        <div class="spacer-small"></div>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="users">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th class="kgk-left">Benutzername</th>
                        <th class="kgk-center">Stadt</th>
                        <th style="white-space:nowrap"># Läufe</th>
                        <th>Gelaufene Kilometer</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users"
                        :key="user.identifier">
                        <td class="kgk-left">
                            <div class="kgk-mobile-th">Platzierung:</div>
                            <span class="kgk-ranking-num">{{ index + 1 }}.</span>
                        </td>
                        <td class="kgk-left">
                            <div class="kgk-mobile-th">Benutzername:</div>
                            {{ user.username }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Stadt:</div>
                            {{ user.city }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Läufe:</div>
                            {{ user.run_count }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Kilometer:</div>
                            <strong>{{ convertNumberReadable(user.total_length, 2) }} km</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardCompanyCompetition',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Rangliste im Unternehmen',
            },
        },
        data() {
            return {
                users: null,
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true;

            leaderboard.getCompanyCompetition(
                this,
                data => this.users = data.users,
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>
